import TextInputField from "../../../Fields/TextInputField";

export default function NameTitleFields({ name, title, onChange }) {
  return (
    <div className="flex gap-6 py-4">
      <TextInputField
        label="Name"
        placeholder="Add Name"
        value={name}
        onChange={onChange("name")}
        className="w-1/2"
      />
      <TextInputField
        label="Title"
        placeholder="Add Title"
        value={title}
        onChange={onChange("title")}
        className="w-1/2"
      />
    </div>
  );
}
